import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const ConsultDoctor = () => {
  return (
    <Box>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Consult Doctor
        </Typography>
        <Typography variant="body1">
          Doctor consultation coming soon...
        </Typography>
      </Container>
    </Box>
  );
};

export default ConsultDoctor;
